import { render, staticRenderFns } from "./debugAdd.vue?vue&type=template&id=396daa85"
import script from "./debugAdd.vue?vue&type=script&lang=js"
export * from "./debugAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports